import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query ActiveProjectTypes($id: ID!, $workspaceId: ID, $category: String) {
    customer(id: $id) {
      id
      activeProjectTypes(workspaceId: $workspaceId, category: $category)
    }
  }
`;

export const queryActiveProjectType = (customerId, workspaceId, category) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: { id: customerId, workspaceId, category },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const result = getSingleProp(data);
      return (result && result.activeProjectTypes) || [];
    });
};
